// Extend namespace by creating a new object
pyzel.quiver = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.quiver.init = function() {

	if ( $('.js-quiver-image').length ) {
		pyzel.quiver.imageFixed();
	}

};


pyzel.quiver.imageFixed = function() {

	console.log('fixing image');

	var
		elImage = $('.js-quiver-image'),
		elEndScroll = $('.js-quiver-end-scroll'),
		elSurfboardsContainer = $('.js-quiver-surfboards-container')
	;

	console.log( "elImage.offset().top" );
	console.log( elImage.offset().top );


	elImage.affix({
		offset: {
			top: (elImage.offset().top + elImage.outerHeight() - window.innerHeight),
			bottom: function () {
				return (this.bottom = elEndScroll.outerHeight(true))
			}
		}
	});

	elImage.on('affixed.bs.affix', function(){

		//console.log( 'affixed.bs.affix' );

		//$('#quiver-rider-picture').css();

		let dir = '';

		$( window ).on('wheel', ( e )=> {

			let delta = e.originalEvent.deltaY;
		
			if (delta > 0){ 
				console.log( 'down' );
				dir = '+';
			}else{ 
				console.log( 'up' );
				dir = '-';
			}
				
			//console.log('we seem to be scrolling.. or wheeling ( and listenning to it )');
			$('#quiver-rider-picture').stop().animate({'background-position': dir+'=10%' }, 500, 'linear');

			//$('#quiver-rider-picture').animate("-webkit-filter", "hue-rotate("+Math.random() * 360 +"deg)");

		})		

		elSurfboardsContainer.addClass('col-md-offset-6');
	});

	elImage.on('affixed-top.bs.affix', function(){

		//console.log( 'affixed-top.bs.affix' );

		$( window ).off('wheel');

		elSurfboardsContainer.removeClass('col-md-offset-6');

	});

	elImage.on('affixed-bottom.bs.affix', function(){

		//console.log( 'affixed-bottom.bs.affix' );

		$( window ).off('wheel');

		elSurfboardsContainer.removeClass('col-md-offset-6');

	});

};